import { FC } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '../ui/button'

interface ChatScrollButtonsProps {
  isAtTop: boolean
  isAtBottom: boolean
  isOverflowing: boolean
  scrollToTop: () => void
  scrollToBottom: () => void
}

/**
 * Scroll control buttons for chat interface
 * Adapted from Chatbot UI
 */
export const ChatScrollButtons: FC<ChatScrollButtonsProps> = ({
  isAtTop,
  isAtBottom,
  isOverflowing,
  scrollToTop,
  scrollToBottom
}) => {
  if (!isOverflowing) return null

  return (
    <div className="flex flex-col space-y-1">
      {!isAtTop && (
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8 rounded-full bg-background shadow-md hover:bg-accent"
          onClick={scrollToTop}
          title="Scroll to top"
          aria-label="Scroll to top of chat"
        >
          <ChevronUp className="h-4 w-4" aria-hidden="true" />
        </Button>
      )}
      
      {!isAtBottom && (
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8 rounded-full bg-background shadow-md hover:bg-accent"
          onClick={scrollToBottom}
          title="Scroll to bottom"
          aria-label="Scroll to bottom of chat"
        >
          <ChevronDown className="h-4 w-4" aria-hidden="true" />
        </Button>
      )}
    </div>
  )
}
